import performanceNewList from "./list.vue";
import detailList from "./detailList.vue";
let a = Object.assign({ performanceNewList, detailList })
export default a;
